import React from 'react';

import PropTypes from 'prop-types';

import type { AmountInputRef, Props } from './';
import AmountInput from './';

const AmountInputWithRef = React.memo(
  React.forwardRef((props: Props, ref: React.Ref<AmountInputRef>) => (
    <AmountInput {...props} innerRef={ref} />
  )),
);

export default AmountInputWithRef;
